(function () {
    'use strict';

    var jhiItemCount = {

        template: '<div class="info">' +
            'نمایش {{(($ctrl.page-1) * $ctrl.itemsPerPage)==0 ? 1:(($ctrl.page-1) * $ctrl.itemsPerPage + 1)}} - ' +
            '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
            '  از {{$ctrl.queryCount}}  مورد' +
            '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: "=?"
        },
        controller: JhiItemCountController
    };

    JhiItemCountController.$inject = ['$scope', '$element', 'paginationConstants'];

    function JhiItemCountController($scope, $element, paginationConstants) {
        var $ctrl = this;

        if (!$ctrl.itemsPerPage)
            $ctrl.itemsPerPage = 20;


    }

    angular
        .module('tikonApp')
        .component('jhiItemCount', jhiItemCount);
})();
